<abp-modal
  [visible]="isVisible()"
  [suppressUnsavedChangesWarning]="true"
  (visibleChange)="onVisibleChange($event)">
  <ng-template #abpHeader>
    <div class="modal-header-title">
      <h3>{{ modalTitle() }}</h3>
      @if (tableLabel()) {
        <h4>{{ tableLabel() }}</h4>
      }
    </div>
  </ng-template>

  <ng-template #abpBody>
    <form class="zn-form" [formGroup]="filterForm">
      <div class="row">
        @for (field of fields; track field.key) {
          <div class="col-12">
            <app-pre-access-filter-field
              class="form-control-container"
              [field]="field"
              [parentForm]="filterForm"
              [formControlName]="field.key"
            ></app-pre-access-filter-field>
          </div>
        }
      </div>
    </form>
  </ng-template>

  <ng-template #abpFooter>
    <zn-button
      type="secondary"
      [label]="translate('LanguageService::Close')"
      (clicked)="onClose()">
    </zn-button>
    <zn-button
      type="primary"
      [label]="translate('LanguageService::Filter')"
      (clicked)="onApplyFilters()">
    </zn-button>
  </ng-template>
</abp-modal>
